import { http } from '@/services';

export default {
    getErrorList: async function() {
    try {
        return await http.get('erro/');
      } catch (e) {
        return e.response.data;
      }
    },
    getError: async function(errorId){
        try{
          return await http.get(`erro/${errorId}`);
        }catch(e){
          return e.response.data
        }
    },
    createError: async function(newError) {
        try {
          return await http.post('erro/', newError);
        } catch (e) {
          return e.response.data;
        }
      },
    deleteError: async function(errorId) {
        try {
          return await http.delete(`erro/${errorId}`, errorId);
        } catch (e) {
          return e.response.data;
        }
    }
  
}